import { useState, useEffect } from "react";
import {getInspectionItems} from "../api/inspetionItemApi";
import {errorStatusHandle} from "../utils/error-utils";
import {clearPageLoading, setPageLoading} from "../store/actions";
import {useDispatch} from "react-redux";
import {getEditInspectionItemPageSettings} from "../api/setting/pageApi";
import {setPageSettings} from "../store/actions/pageActions";
import {getGroupAndMachines} from "../utils/group-option-utils";

const useInspection = (template_id) => {
  const dispatch = useDispatch();
  const [template, setTemplate] = useState([]);
  const [inspectionItems, setInspectionItems] = useState([]);
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    dispatch(setPageLoading());
    getEditInspectionItemPageSettings().then((pageSettings) => {
      dispatch(setPageSettings(pageSettings));
      const {groupListOptions, groupAndChildrenOptions} = getGroupAndMachines(pageSettings.options);
      setMachines(pageSettings.options?.machines);
      setGroupsList(groupListOptions);
      setGroupsChildren(groupAndChildrenOptions);
      dispatch(clearPageLoading());
    }).catch((e) => {
      errorStatusHandle(e);
    });

    getInspectionItems(template_id).then((data) => {
      setTemplate(data.template);
      setInspectionItems(data.inspection_items);
    }).catch(e => {
      errorStatusHandle(e);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {template, inspectionItems, groupsList, groupsChildren, machines};
}

export default useInspection;
